module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-infos-containter_2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-offset-1 col-lg-10 all-infos-wrap"
  }, [_c('div', {
    staticClass: "all-infos-wrap-d"
  }, [_c('ol', {
    staticClass: "navbar-wrap row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sonModules), function(sonModule, index) {
    return _c('li', {
      key: index,
      staticClass: "col-md-2 col-sm-2 col-xs-3",
      class: {
        activedecoration: _vm.activeToSon == sonModule.to
      },
      on: {
        "click": function($event) {
          return _vm.selected(sonModule)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": sonModule.to
      }
    }, [_vm._v(_vm._s(_vm.$t(("service." + (sonModule.name)))))])], 1)
  })], 2), _vm._v(" "), _c('h5', {
    staticClass: "title-url-address"
  }, [_c('span', [_vm._v("当前位置:")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.home")) + ">")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.about")) + ">")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t(("service." + _vm.prodectTab)))
    }
  })]), _vm._v(" "), _c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-2 col-sm-2 col-xs-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/sign-1-01.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-443c3e77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Service.vue
// module id = 268
// module chunks = 1